define('app-SearchResults/modules/batBelt/module',['./settings', 'text!./view.html', 'text!./viewCruise.html', './viewModel', 'knockout'], function (settings, view, viewCruise, ViewModel, ko) {
    return {
        initialise: function (globalSettings) {
            window.loadedModules('Batbelt (SearchResults)');


            var batBelt = view;
            if ($("body").hasClass("cruise")) {
                batBelt = viewCruise;
            }

            $(batBelt).hide();
            $(globalSettings.overallContainer + ' ' + settings.container).append(batBelt);
            $(batBelt).slideDown(50);

            

            var viewModel = new ViewModel(globalSettings);
            ko.applyBindings(viewModel, $(globalSettings.overallContainer + ' ' + settings.container)[0]);
        }
    };
});
